<template>
  <el-form ref="baseForm" class="from_box flex" style="border:1px solid #d2e7fd;padding:30px" :rules="rules" :model="formData">
    <el-form-item class="item" label="租户编码：" prop="tenantCode">
      <el-input type="text" placeholder="暂无" v-model="formData.tenantCode"></el-input>
    </el-form-item>

    <el-form-item class="item" label="租户描述：" prop="tenantDesc">
      <el-input type="text" placeholder="暂无" v-model="formData.tenantDesc"></el-input>
    </el-form-item>

    <el-form-item class="item" label="法定人：" prop="legalPerson">
      <el-input type="text" placeholder="暂无" v-model="formData.legalPerson"></el-input>
    </el-form-item>

    <el-form-item class="item" label="公司邮箱：" prop="companyEmail">
      <el-input type="text" placeholder="请输入公司邮箱" v-model="formData.companyEmail"></el-input>
    </el-form-item>

    <el-form-item class="item" label="识别号：" prop="identificationNum">
      <el-input type="text" placeholder="暂无" v-model="formData.identificationNum"></el-input>
    </el-form-item>

    <el-form-item class="item" label="国家：" prop="countryCode">
      <el-select filterable v-model="formData.countryCode" placeholder="请选择">
        <el-option
          v-for="(item,index) in cities"
          :key="index"
          :label="item.zh"
          :value="item.locale"
        >
          <span style="float: left">{{ item.locale}}</span>
          <span style="float: right; color: #8492a6; font-size: 13px">{{ item.zh}}</span>
        </el-option>
      </el-select>
    </el-form-item>

    <el-form-item class="item" label="区域：" prop="region">
      <el-input type="text" placeholder="暂无" v-model="formData.region"></el-input>
    </el-form-item>

    <el-form-item class="item" label="注册地：" prop="regStreet">
      <el-input type="text" placeholder="暂无" v-model="formData.regStreet"></el-input>
    </el-form-item>

    <el-form-item class="item" label="街道：" prop="street">
      <el-input type="text" placeholder="暂无" v-model="formData.street"></el-input>
    </el-form-item>

    <el-form-item class="item" label="社会信用代码：" prop="uscc">
      <el-input type="text" placeholder="暂无" v-model="formData.uscc"></el-input>
    </el-form-item>

    <el-form-item class="item" label="业务范围："  style="width:100%" prop="businessScope">
      <el-input type="textarea" :rows="2" placeholder="暂无" v-model="formData.businessScope"></el-input>
    </el-form-item>
  </el-form>
</template>

<script>
import { URL_PLATFORM_RESOURCE as URL } from "../service/TenantManage.service.js";
import countryCode from "mock/countryCode.json";

export default {
  components: {},
  props: {
    formData: Object
  },
  data() {
    return {
      cities: countryCode,
      textarea: "",
      rules: {
        companyEmail:[{
          required: true,
          pattern:/^[A-Za-z0-9\u4e00-\u9fa5.]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
          message: "请输入正确的邮箱格式",trigger: "blur"
        }],
        tenantCode: [
          {
            required: true,
            message: "请输入租户代码",
            trigger: "blur"
          }
        ],
        tenantDesc: [
          {
            required: true,
            message: "请输入租户名",
            trigger: "blur"
          }
        ],
        legalPerson: [
          {
            required: true,
            message: "请输入法定人",
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {},
  methods: {
    validataForm(cb) {
      let vm=this;
      vm.$refs["baseForm"].validate(vaild => {
          if(cb&&vaild){
            cb(vm.formData);
          }
      });
    }
  }
};
</script>

<style>
</style>
